<template>
  <v-container>
    <v-toolbar color="primary" dark>
      <v-toolbar-title dark>Пресса</v-toolbar-title>
      <!--            <v-spacer></v-spacer>-->
      <template v-slot:extension>
        <v-tabs fixed-tabs color="primary" active-class="active-tab">
          <v-tabs-slider color="#FDE700"></v-tabs-slider>
          <v-tab
            ref="newspapers_list"
            key="newspapers"
            :to="{ name: 'newspapers_list', params: { site_key: $attrs.site_key } }"
          >
            Газеты
          </v-tab>
          <v-tab
            key="brochures"
            :to="{ name: 'brochures_list', params: { site_key: $attrs.site_title } }"
            >Брошюры</v-tab
          >
          <v-tab
            key="magazines"
            :to="{ name: 'magazines_list', params: { site_key: $attrs.site_title } }"
            >Журналы</v-tab
          >
          <v-tab
            key="program-article"
            :to="{ name: 'program_article_list', params: { site_key: $attrs.site_title } }"
            >Программная статья</v-tab
          >
        </v-tabs>
      </template>
    </v-toolbar>
    <router-view
      name="press"
      :site_key="$attrs.site_key"
      :site_title="$attrs.site_title"
    ></router-view>
  </v-container>
</template>

<script>
export default {
  name: 'press',
  mounted() {
    this.$refs.newspapers_list.click({})
    this.$log.debug('press click')
  },
  update() {
    this.$refs.newspapers_list.click({})
    this.$log.debug('press click')
  },
}
</script>
